
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getQuestionBank, getQuestionnaire, addQuestionnaire, addQuestionnaireQuestion, editQuestionnaire, delQuestionnaire } from '@/api/question';

@Component({
  name: 'SettingTemplateQuestionnaire',
  components: {

  }
})
export default class extends Vue {
  // @Prop({
  //   type: String,
  //   default: ''
  // })
  // create!: String;

  private flag: any = 1
  private dataList: any = []
  private radioQuestion:any = { id: -1 };
  private oldradioQuestion:any={ id: -1 };
  private tableQuestionnaire: any = []
  private tableQuestionBank:any=[]
  private isBankLoading = false
  private multipleSelected = []

  created() {
    this.getQuestionnaire(false, false);
  }
  private getQuestionnaire(isEdit:boolean, isRefish:boolean) {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    getQuestionnaire(pamars).then((res:any) => {
      if (res.data) {
        this.dataList = res.data.list;
        // this.radioQuestion = this.oldradioQuestion;
        if (this.dataList && this.dataList.length > 0) {
          if (isEdit) {
            this.radioQuestion = this.dataList[this.dataList.length - 1];
            this.oldradioQuestion = this.dataList[this.dataList.length - 1];
            this.tableQuestionnaire = this.dataList[this.dataList.length - 1].question_list;
          } else {
            if (this.oldradioQuestion.id !== this.dataList[0].id && parseInt(this.oldradioQuestion.id) !== 0 && parseInt(this.oldradioQuestion.id) !== -1) {
              this.radioQuestion = this.oldradioQuestion;
              for (let i = 0; i < this.dataList.length; i++) {
                if (this.dataList[i].id === this.radioQuestion.id) {
                  this.tableQuestionnaire = this.dataList[i].question_list;
                  this.radioQuestion = this.dataList[i];
                }
              }
            } else {
              if (this.addQuesId) {
                for (let i = 0; i < this.dataList.length; i++) {
                  if (this.addQuesId === this.dataList[i].id) {
                    this.tableQuestionnaire = this.dataList[i].question_list;
                    this.radioQuestion = this.dataList[i];
                  }
                }
              } else {
                this.radioQuestion = this.dataList[0];
                this.oldradioQuestion = this.dataList[0];
                this.tableQuestionnaire = this.dataList[0].question_list;
              }
            }
          }
        } else {
          this.dataList = [];
          this.tableQuestionnaire = [];
        }
      }
    }).catch(err => {
      this.tableQuestionnaire = [];
      this.dataList = [];
      let msg = err.msg;
    });
  }
  private getQuestionBank() {
    this.isBankLoading = true
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    getQuestionBank(pamars).then((res:any) => {
      if (res.data) {
        this.isBankLoading = false
        this.tableQuestionBank = res.data.list;
        this.flag = 2;
        (this.$refs.multipleTable as any).toggleAllSelection();
      } else {
        this.$alert('新建问卷没有题，请去题库管理', '', {
          confirmButtonText: '确定',
          callback: action => {
            this.radioQuestion = this.currentRadio
          }
        });
      }
    }).catch(err => {
      let msg = err.msg;
      this.isBankLoading = true
    });
  }
  private addQuertion() { // 问卷新增问题
    // 从题库中选择
    this.getQuestionBank();
  }
  private deleteQuestHandle() { // 删除问卷
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.id = this.radioQuestion.id;

    delQuestionnaire(pamars).then((res:any) => {
      this.oldradioQuestion = { id: 0 };
      this.showSuccessMsg(res.msg);
      this.flag = 1;
      this.getQuestionnaire(false, true);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private submitQuestHandle() { // 保存问卷
    if (!this.multipleSelected || this.multipleSelected.length < 1) {
      this.showErrorMsg('请选择问题');
      return;
    }
    let that = this;
    this.$prompt('', '问卷名称', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入问卷名称',
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
      inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称',
      inputValue: this.radioQuestion.questionnaire_name
    })
      .then(({ value }: any) => {
        let pamars:any = {};
        pamars.company_id = UserModule.getCompanyId;
        pamars.user_id = UserModule.getUserId;
        pamars.id = this.radioQuestion.id;
        pamars.questionnaire_name = value;
        pamars.question = JSON.stringify(this.multipleSelected);
        editQuestionnaire(pamars).then((res:any) => {
          that.flag = 1;
          that.showSuccessMsg(res.msg);
          that.getQuestionnaire(true, true);
        }).catch(err => {
          that.showErrorMsg(err.msg);
        });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '取消输入'
        // });
      });
  }
  private currentRadio = ''
  private questionnaireSelect(val:any) {
    if (parseInt(val.id) === 0) {
      this.getQuestionBank();
    } else {
      this.currentRadio = val
      this.oldradioQuestion = val;
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id === this.radioQuestion.id) {
          this.tableQuestionnaire = this.dataList[i].question_list;
        }
      }
    }
  }
  private questionnaireSelectionChange(val: any) {
    this.multipleSelected = val;
  }
  private addCancel() {
    if (parseInt(this.oldradioQuestion.id) === 0) {
      this.oldradioQuestion = { id: -1 };
    }
    this.radioQuestion = this.oldradioQuestion;
    for (var i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id === this.radioQuestion.id) {
        this.tableQuestionnaire = this.dataList[i].question_list;
      }
    }
    this.flag = 1;
  }
  private addQuesId = ''
  private addConfirm() {
    if (!this.multipleSelected || this.multipleSelected.length < 1) {
      this.showErrorMsg('请选择问题');
      return;
    }
    if (parseInt(this.radioQuestion.id) === 0 || parseInt(this.radioQuestion.id) === -1) {
      let that = this;
      this.$prompt('', '问卷名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入问卷名称',
        inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
        inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称'
      })
        .then(({ value }: any) => {
          let pamars:any = {};
          pamars.company_id = UserModule.getCompanyId;
          pamars.user_id = UserModule.getUserId;
          pamars.questionnaire_name = value;
          pamars.question = JSON.stringify(this.multipleSelected);
          addQuestionnaire(pamars).then((res:any) => {
            that.showSuccessMsg(res.msg);
            this.addQuesId = res.data.id;
            that.flag = 1;
            that.getQuestionnaire(false, true);
          }).catch(err => {
            that.showErrorMsg(err.msg);
          });
        }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '取消输入'
        // });
        });
    } else {
      let pamars:any = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.user_id = UserModule.getUserId;
      pamars.id = this.radioQuestion.id;
      pamars.question = JSON.stringify(this.multipleSelected);
      addQuestionnaireQuestion(pamars).then((res:any) => {
        this.flag = 1;
        this.showSuccessMsg(res.msg);
        // this.radioQuestion = this.oldradioQuestion;
        this.getQuestionnaire(false, true);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
